module.exports = __webpack_public_path__ + "static/media/in-number-1.1bf62e27.png";